import React from 'react';
import { Link, navigate } from 'gatsby';
import styles from './loginform.module.scss';
import { Input, Grid, Button, Message } from 'semantic-ui-react';
import cx from 'classnames';
import arcLogo from '../../images/logo.png';

export default class LoginForm extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			caseNumber: '',
			password: '',
			invalidFields: {
				caseNumber: false,
				password: false
			}
		};
		
		this.performLogin = this.performLogin.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.getValidationError = this.getValidationError.bind(this);
		this.isFieldValid = this.isFieldValid.bind(this);
		this.getErrorMessage = this.getErrorMessage.bind(this);
		this.changePassword = this.changePassword.bind(this);
	}
	
	performLogin() {
		if (this.state.caseNumber === '' && this.state.password === '') {
			this.setState({
				invalidFields: {
					caseNumber: true,
					password: true
				}
			});
		} else if (this.state.caseNumber === '' && this.state.password !== '') {
			this.setState({
				invalidFields: {
					caseNumber: true,
					password: false
				}
			});
		} else if (this.state.password === '' && this.state.caseNumber !== '') {
			this.setState({
				invalidFields: {
					caseNumber: false,
					password: true
				}
			});
		} else {
			this.setState({
				invalidFields: {
					caseNumber: false,
					password: false
				}
			});
			// console.log('performing login');
			this.props.login({
				caseNumber: this.state.caseNumber,
				password: this.state.password
			});
		}
	}
	
	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}
	
	getValidationError(fieldName) {
		
		if (typeof this.props.validationErrors !== 'undefined' && this.props.validationErrors !== null && typeof this.props.validationErrors !== 'string') {
			const fieldIndex = this.props.validationErrors.findIndex((el) => {
				return el.field === fieldName;
			});
			if (fieldIndex > -1) {
				return this.props.validationErrors[fieldIndex].error;
			}
		}
		if (this.state.invalidFields[fieldName]) {
			const fieldNameErr = 'Please insert your valid ' + fieldName;
			return (fieldNameErr);
		}
	}
	
	isFieldValid(fieldName) {
		if (typeof this.props.validationErrors !== 'undefined' && this.props.validationErrors !== null && typeof this.props.validationErrors !== 'string') {
			const fieldIndex = this.props.validationErrors.findIndex((el) => {
				return el.field === fieldName;
			});
			if (fieldIndex > -1) {
				return true;
			} else {
				return false;
			}
		}
		return this.state.invalidFields[fieldName];
	}
	
	getErrorMessage() {
		if (typeof this.props.validationErrors === 'string') {
			return (
				<Message color='red'>Please insert valid case no.</Message>
			);
		}
	}
	
	changePassword() {
		navigate('/forget');
	}
	
	
	render() {
		return (
			<div className={styles.initialWrap}>
				<div className={styles.centerBox}>
					<div className={cx(styles.centerBoxContent, styles.centerBoxWithBg)}>
						<div className={styles.formMetaContainer}>
							<Grid columns="equal">
								<Grid.Row>
									<Grid.Column className={styles.gridTextCenter}>
										{this.getErrorMessage()}
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</div>
						<div className={styles.initialLogo}>
							<img src={arcLogo} alt="ARC"/>
						</div>
						<h1>Welcome to Activities for Reading Comprehension - ARC!</h1>
						<p>Please insert your User number and password and select Log In to enter the app.</p>
						<div className={styles.formWrap}>
							<div
								className={cx(styles.formInputGroup, styles.formInputGroupMarginTop, (this.isFieldValid('caseNumber') || this.state.invalidFields.caseNumber) && styles.usernameFieldError)}>
								<Input
									name="caseNumber"
									placeholder="User No."
									value={this.state.caseNumber}
									className={cx(styles.formInputControl)}
									onChange={(event => this.handleInputChange(event))}
								/>
								<div className={styles.errorMessage}>{this.getValidationError('caseNumber')}</div>
							</div>
							
							<div
								className={cx(styles.formInputGroup, styles.inputGroupMargin, (this.isFieldValid('password') || this.state.invalidFields.password) && styles.passwordFieldError)}>
								<Input
									name="password"
									placeholder="Password"
									value={this.state.password}
									type="password"
									className={cx(styles.formInputControl)}
									onChange={(event => this.handleInputChange(event))}
								/>
								<div className={styles.errorMessage}>{this.getValidationError('password')}</div>
							</div>
							<div className={styles.formActionContainer}>
								<Button
									onClick={() => this.performLogin()}
									className={cx(styles.loginFormBtn)}
									loading={this.props.loading}
								>
									Log In
								</Button>
							</div>
							<div className={styles.forgotPasswordWrap}>
								<Link to="/reset-password" className={cx(styles.formLink)}>Forgot Password?</Link>
							</div>
						</div>
					</div>
					{/*<div className={styles.loginFormContainer}>*/}
					{/*     <div className={styles.formMetaContainer}>*/}
					{/*    <Grid columns="equal">*/}
					{/*        <Grid.Row>*/}
					{/*            <Grid.Column className={styles.gridTextCenter}>*/}
					{/*                {this.getErrorMessage()}*/}
					{/*            </Grid.Column>*/}
					{/*        </Grid.Row>*/}
					{/*    </Grid>*/}
					{/*</div> */}
					{/*</div>*/}
				</div>
			</div>
		);
	}
}
